import {LayoutModule} from '@angular/cdk/layout';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {RouterModule} from '@angular/router';
import {NgcCookieConsentConfig, NgcCookieConsentModule} from 'ngx-cookieconsent';
import {SharedModule} from '../shared/shared.module';
import {ContactComponent} from './containers/contact/contact.component';
import {DownloadComponent} from './containers/download/download.component';
import {ImprintComponent} from './components/content-pages/imprint/imprint.component';
import {PrivacyComponent} from './components/content-pages/privacy/privacy.component';
import {TacComponent} from './components/content-pages/tac/tac.component';
import {CookieNoticeComponent} from './components/cookie-notice/cookie-notice.component';
import {FooterComponent} from './components/footer/footer.component';
import {GlobalMessageComponent} from './components/global-message/global-message.component';
import {HeaderComponent} from './components/header/header.component';
import {SiteMenuFooterComponent} from './components/site-menu/site-menu-footer/site-menu-footer.component';
import {SiteMenuComponent} from './components/site-menu/site-menu.component';
import {ContentPageComponent} from './containers/content-page/content-page.component';
import {PageNotFoundComponent} from './containers/page-not-found.component';
import {SiteMenuPageComponent} from './containers/site-menu-page/site-menu-page.component';
import {throwIfAlreadyLoaded} from './module-import-guard';
import {LanguageInterceptorService} from './services/language-interceptor.service';
import {LanguageService} from './services/language.service';
import {SerachbarComponent} from './components/searchbar/serachbar.component';
import {CmsModule} from '../cms/cms.module';

const ENTRY_COMPONENTS = [
    ImprintComponent,
    PrivacyComponent,
    TacComponent,
    DownloadComponent,
    ContactComponent
];

export const COMPONENTS = [
    ENTRY_COMPONENTS,
    HeaderComponent,
    FooterComponent,
    PageNotFoundComponent,
    ContentPageComponent,
    GlobalMessageComponent,
    SiteMenuPageComponent,
    SiteMenuComponent,
    SiteMenuFooterComponent,
    CookieNoticeComponent,
    SerachbarComponent
];
export const httpInterceptorProviders = [
    {provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptorService, multi: true},
];

const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: 'localhost'
        // will be reset in cookie notice component
    },
    position: 'bottom',
    theme: 'block',
    palette: {
        popup: {
            background: '#ffffff',
            text: '#63666a',
            link: '#43464a'
        },
        button: {
            background: '#43464a',
            text: '#eceded',
            border: 'transparent'
        }
    },
    type: 'opt-in'
};

@NgModule({
    imports: [
        SharedModule,
        RouterModule,
        LayoutModule,
        CmsModule,
        NgcCookieConsentModule.forRoot(cookieConfig)
    ],
    exports: [COMPONENTS],
    declarations: [COMPONENTS],
    providers: [
        {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'standard'}},
        LanguageService,
        httpInterceptorProviders
    ],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
